import React from 'react';
import moment from 'moment';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import 'moment-duration-format';
import Calendar from './Calendar';
import Select from 'react-select';

import { ModalLoadingPage } from 'APP_ROOT/components/common/loadingPage';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';


class CardSelectCard extends React.PureComponent {
    constructor(props) {

        super(props);

        this.state = {
            parkedLocation: null,
            startLocation: null,
            endLocation: null,
        };

        this.componentIsMounted = true; // avoid state updates when componentWillUnmount (halt setStates during getLocationFeatures callbacks)
    }

    componentWillUnmount() {
        this.componentIsMounted = false;
    }

    updateStartAndEndLocations() {
        var obj = {};
        var updat = false;

        if(!this.state.startLocation)
        {
            if(this.props.card && this.props.card.start)
            {
                if(this.props.card.start.locationName && this.props.card.start.locationName.trim()) {
                    obj.startLocation = this.props.card.start.locationName;
                    updat = true;
                }
                else
                {
                    RavenUtil.getLocationFeatures(
                        this.props.card.start.lon, this.props.card.start.lat, 
                        (loc) => this.updateLocation("startLocation", loc), 
                        (loc) => this.errorUpdatingLocation("startLocation", loc)
                    );
                    obj.startLocation = strings.loading;
                    updat = true;
                }
            }
        }

        if(!this.state.endLocation)
        {
            if(this.props.card && this.props.card.end)
            {
                if(this.props.card.end.locationName && this.props.card.end.locationName.trim())
                {
                    obj.endLocation = this.props.card.end.locationName;
                    updat = true;
                }
                else
                {
                    RavenUtil.getLocationFeatures(this.props.card.end.lon, this.props.card.end.lat, 
                        (loc) => this.updateLocation("endLocation", loc), 
                        (loc) => this.errorUpdatingLocation("endLocation", loc)
                    );
                    obj.endLocation = strings.loading;
                    updat = true;
                }
            }
        }

        if(updat)
            this.setState({
                ...obj
            });
    }


    updateLocation = (statePropertyName, locationFeatures) => {

        if (this.componentIsMounted === false) return;

        let locationName = RavenUtil.getLocationName(locationFeatures, true);

        if (!locationName) {
            console.warn("CardSelectPanel locationName not found");
            locationName = strings.unknown;
        }

        this.setState({
            [statePropertyName] : locationName
        });
    }

    errorUpdatingLocation = (name, e) => {

        if (this.componentIsMounted === false) return;

        var obj = {};
        obj[name] = strings.unknown;
        this.setState(obj);
    }

    renderParkedCard(card, index, selected, durationTimestamp, numstops) {

        var classes = "day-card parked";
        if (selected) {
            classes += " selected";
        }

        if (!this.state.parkedLocation) {
            if(card.start)
            {
                RavenUtil.getLocationFeatures(card.start.lon, card.start.lat, 
                    (loc) => this.updateLocation("parkedLocation", loc), 
                    (loc) => this.errorUpdatingLocation("parkedLocation", loc)
                );
            }
            else
            {
                this.updateLocation("parkedLocation", strings.unknown);
            }
        }

        return ( 
            <button className={classes} key={card.cardId} onClick={() => this.props.selectCard(card.cardId)}>
                <div className="timeline-symbols">{/* left hand side div, timeline graphical elements */}
                    <div>&nbsp;</div>
                    <div className="green-p">{strings.parked_letter_symbol}</div>
                    <div>&nbsp;</div>
                </div>
                <div className="card-details">{/* stretch-to-fit  div, timeline graphical elements */}
                    <div className="location-name">{this.state.parkedLocation ? this.state.parkedLocation : <span>&nbsp;</span>}</div>
                    <div className="duration">{durationTimestamp}{numstops}</div>
                </div>
                <div className="card-timestamps">
                    <div>{new Date(card.start.ts).toLocaleTimeString(getCurrentLocale(), {timeStyle: "short"})}</div>
                    { card.end.ts ? 
                        <div>{new Date(card.end.ts).toLocaleTimeString(getCurrentLocale(), {timeStyle: "short"})}</div> :
                        null
                    }
                </div>
            </button> 
        );
    }

    renderDrivingCard(card, index, selected, durationTimestamp, numstops) {

        var classes = "day-card driving";
        if (selected) {
            classes += " selected";
        }

        this.updateStartAndEndLocations();

        return (
            <button className={classes} key={card.cardId} onClick={() => this.props.selectCard(card.cardId)}>
                <div className="timeline-symbols">{/* left hand side div, timeline graphical elements */}
                    <div className="timeline-marker"><img src="/svg/timeline-icon-start-green.svg" /></div>
                    <div className="timeline-route">
                        <div className="timeline-route-line"></div>
                        <div className="timeline-route-arrow"><i className="arrow down"></i></div>
                    </div>
                    <div className="timeline-marker"><img src="/svg/timeline-icon-start-purple.svg" /></div>
                </div>
                <div className="card-details">
                    <div className="location-name">{this.state.startLocation}</div>
                    <div className="distance">{RavenUtil.distanceString(card.distance, this.props.unitOfMeasure)}</div>
                    <div className="duration">{durationTimestamp}{numstops}</div>
                    <div className="location-name">{this.state.endLocation}</div>
                </div>
                <div className="card-timestamps">
                    <div>{new Date(card.start.ts).toLocaleTimeString(getCurrentLocale(), {timeStyle: "short"})}</div>
                    { card.end.ts ? 
                        <div>{new Date(card.end.ts).toLocaleTimeString(getCurrentLocale(), {timeStyle: "short"})}</div> : 
                        null
                    }
                </div>
            </button>
        );
    }

    render() {
        var startMs = new Date(this.props.card.start.ts);
        var endMs = new Date(this.props.card.end.ts);
        var durationTimestamp = strings.unknown;
        try {
            if (this.props.card.end.ts === null) durationTimestamp = strings.ongoing;
            else {
                durationTimestamp = moment.duration(endMs - startMs).humanize();
            }
        } catch (e) {
            console.warn("Unable to set card timestamp", e);
        }

        var numstops = Math.floor(this.props.card.segments.length/2);
        numstops = (numstops > 0) ? " (" + numstops + (numstops === 1 ? " " + strings.stop + ")" : " " + strings.stops + ")") : null;

        return this.props.card.type === 'PARKED' ? 
                this.renderParkedCard(this.props.card, this.props.index, this.props.selected, durationTimestamp, numstops) : 
                this.renderDrivingCard(this.props.card, this.props.index, this.props.selected, durationTimestamp, numstops);
    }
}

export default class CardSelectPanel extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            selectedDate: null
        };
    }

    componentDidMount() {
        this.checkSelectedDate();
    }

    componentDidUpdate(prevProps) {
        this.checkSelectedDate(prevProps.selectCard);
    }

    checkSelectedDate = () => {
        if(!this.state.selectedDate) {
            const { selectedCardId, cards } = this.props;
            if (cards && cards.length) {
                let card = selectedCardId && cards.find(c => c.cardId === selectedCardId);
                if(!card) card = cards[cards.length - 1];
                this.setState({
                    selectedDate: this.cardStartDate(card)
                });
            }
        }
    }

    onDateChanged = (newDate) => {
        this.setState({
            selectedDate: newDate
        });
    }

    cardStartDate = card => new Date(card.start.ts);

    renderCard(card, selectedCardId) {
        return ( 
            <CardSelectCard 
                key={card.cardId}
                card={card}
                selected={card.cardId === selectedCardId}
                unitOfMeasure={this.props.unitOfMeasure}
                selectCard={this.props.selectCard}
            />
        );

    }

    render() {
        if(!this.props.ravens) return null;
        if(!this.props.raven) return null;

        var renderDateCards = [];

        const date = this.state.selectedDate;

        if(this.props.cards && date)
        {

            var cardsOnThisDate = this.props.cards.filter(card => {
                var targetDate = this.cardStartDate(card);
                return targetDate.getDate() === date.getDate() &&
                    targetDate.getMonth() === date.getMonth() &&
                    targetDate.getFullYear() === date.getFullYear();
            });

            var selectedCardId = this.props.match.params.cardId;

            cardsOnThisDate.forEach((card, index) => {

                renderDateCards.push( this.renderCard(card, selectedCardId));

            });
        }

        return (
            <div className="calendar-view">
                <div className="history-calendar">
                    <div className="scroll-wrapper calendar">
                        <div className="ravens-dropdown-row">
                            <div>
                                <RavenDropdown
                                    value={this.props.match.params.ravenUuid}
                                    ravens={this.props.ravens}
                                    onChange={this.props.selectRaven}
                                />
                            </div>
                        </div>
                        <Calendar
                            selectedDate={this.state.selectedDate}
                            onDateChanged={this.onDateChanged}
                            cards={this.props.cards} />
                    </div>

                    <div className="scroll-wrapper trips">
                        <div className="week-container">
                            { this.props.cards && date ?
                                <div className="day-container" >
                                    <div className="day-header">
                                        <h2>{moment(date).format('ddd, MMM')}</h2>
                                        <label>{date.getDate()}</label>
                                    </div>
                                    <div className="day-body">
                                        {renderDateCards}
                                    </div>
                                </div> :
                                <div className="day-container loading-overlay"><ModalLoadingPage style="light-theme-invert" /></div> 
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const RavenDropdown = ({ ravens, value, onChange }) => {
    const options = ravens && ravens.map(raven => ({
        value: raven.ravenUuid,
        label: raven.vehicle && raven.vehicle.name ? raven.vehicle.name : raven.ravenUuid.substring(0,8)
    }));
    return (
        <div className="raven-select">
            <Select
                className="select-heading"
                options={options}
                value={value}
                onChange={(e) => onChange(e && e.value)}
                clearable={false}
                searchable={false}
            />
        </div>
    );
};
